import { Oval } from 'react-loader-spinner';

export default function LoadingSpinner() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <Oval color="#00BFFF" height={80} width={80} />
    </div>
  );
}
